export enum OfflineTransactionType {
  General = "general",
  CreateWorkOrder = "createWorkOrder",
  MediaUpload = "mediaUpload",
  TextAttachment = "textAttachment",
  /** Used when submitting a single question test result (INS_AddTestResult). */
  AddTestResult = "addTestResult",
  CompleteWorkOrder = "completeWorkOrder",
}
